// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".x-PropertiesEditor {\n  width: 100%;\n}\n.x-PropertiesEditor td {\n  border: 1px solid #ccc;\n  padding: 1px 5px;\n}\n.x-PropertiesEditor td.x-PropertiesEditor-name {\n  width: 200px;\n  font-weight: bold;\n}\n.x-PropertiesEditor td.x-PropertiesEditor-caption {\n  font-weight: bold;\n  background-color: #d2d7ee;\n}\n.x-PropertiesEditor td.x-PropertiesEditor-value > * {\n  width: 100%;\n}\n.x-PropertiesEditor td.x-PropertiesEditor-value input {\n  border: none;\n}\n.x-PropertiesEditor-collapseBtn {\n  cursor: pointer;\n}\n.x-PropertiesEditor-collapseBtn:hover {\n  color: #00739d;\n}\n", ""]);
// Exports
exports.locals = {
	"root": "x-PropertiesEditor",
	"name": "x-PropertiesEditor-name",
	"caption": "x-PropertiesEditor-caption",
	"value": "x-PropertiesEditor-value",
	"collapseBtn": "x-PropertiesEditor-collapseBtn"
};
module.exports = exports;
